import { getLang } from  "@/network/mine/mine";
import { commonLangPackage } from "@/config/lang/commonLang";
import { getToken } from '@/utils/auth.js'
/**
 * 获取语言并且 选择语言
 * @param langPackage
 * @returns {string}
 */
function selectLang(langPackage){
    let langtxt = '';
    let commonLang = '';
    let lang = "";
    let type = "cn"
    //调度语言
    //通过后台 redis 获取设置的语言 如果为空则 默认为 cn
    // console.log(getToken());

    return getLang().then(res =>{
        if (res.code == 200){
            if(res.data == "cn"){
                langtxt = langPackage.cn
                //设置通用语言包
                commonLang = commonLangPackage.cn
                type = "cn"
            }else if (res.data == "en"){
                langtxt = langPackage.en;
                commonLang = commonLangPackage.en
                type = "en"
            }
        }
      let lang = {
           common: commonLang,
           langtxt: langtxt,
           type : type
        }
        return lang;
    }).catch(error => {
        //如果没有登录 自动获取中文包
        if (getToken() == null){
            langtxt = langPackage.cn
            //设置通用语言包
            commonLang = commonLangPackage.cn
            type = "cn"
        }
        let lang = {
            common: commonLang,
            langtxt: langtxt,
            type : "cn"
        }
        return lang;
    })


}

export {selectLang}


